<template>
    <div class="Match">

        <a :href="detail + '?match=' + match.id">
            <div class="Match__body">

            <div class="Match__line" :class="{ 'Match__line--winner': winner(match.detail.winner , 'a') }">

                <div class="Match__player__holder">

                    <div class="Match__player">

                        <img class="small-flag" :src="getFlagPath(match.detail.cA)"
                             :alt="match.detail.cA || ''">

                        <span class="Match__player__fn">{{match.detail.nAF}}</span><span class="Match__player__i">{{initial(match.detail.nAF)}}</span>&nbsp;<span
                            class="Match__player__ln">{{match.detail.nAL}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedA">[{{match.detail.seedA}}]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idA )">[Q]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idA )">[WC]</span>

                    </div>

                    <div class="Match__player" v-if="match.detail.isDoubles == 1">

                        <img class="small-flag" :src="getFlagPath(match.detail.cA2)"
                             :alt="match.detail.cA2 || ''">

                        <span class="Match__player__fn">{{match.detail.nA2F}}</span><span class="Match__player__i">{{initial(match.detail.nA2F)}}</span>&nbsp;<span
                            class="Match__player__ln">{{match.detail.nA2L}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedA">[{{match.detail.seedA}}]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idA2 )">[Q]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idA2 )">[WC]</span>

                    </div>

                </div>

                <div v-if="match.detail.serve == '0' || match.detail.serve == '2'"
                     class="Match__serve" v-html="ico_ball">
                </div>

                <div v-if="winner(match.detail.winner , 'a')"
                     class="Match__winner" v-html="ico_winner"></div>

                <div class="Match__set">

                    <ul>
                        <li class="Match__set__pt" v-if="match.detail.ptA">{{match.detail.ptA}}</li>
                        <li v-if="match.detail">
                            {{match.detail.s1A}}<sup v-if="match.detail.s1A < match.detail.s1B">{{match.detail.tb1}}</sup>
                        </li>
                        <li v-if="match.detail.s2A">
                            {{match.detail.s2A}}<sup v-if="match.detail.s2A < match.detail.s2B">{{match.detail.tb2}}</sup>
                        </li>
                        <li v-if="match.detail.s3A">
                            {{match.detail.s3A}}<sup v-if="match.detail.s3A < match.detail.s3B">{{match.detail.tb3}}</sup>
                        </li>
                    </ul>

                </div>

            </div>

            <div class="Match__line" :class="{ 'Match__line--winner': winner(match.detail.winner , 'b') }">

                <div class="Match__player__holder">

                    <div class="Match__player">

                        <img class="small-flag" :src="getFlagPath(match.detail.cB)"
                             :alt="match.detail.cB || ''">

                        <span class="Match__player__fn">{{match.detail.nBF}}</span><span class="Match__player__i">{{initial(match.detail.nBF)}}</span>&nbsp;<span
                            class="Match__player__ln">{{match.detail.nBL}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedB">[{{match.detail.seedB}}]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idB )">[Q]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idB )">[WC]</span>

                    </div>

                    <div class="Match__player" v-if="match.detail.isDoubles == 1">

                        <img class="small-flag" :src="getFlagPath(match.detail.cB2)"
                             :alt="match.detail.cB2 || ''">

                        <span class="Match__player__fn">{{match.detail.nB2F}}</span><span class="Match__player__i">{{initial(match.detail.nB2F)}}</span>&nbsp;<span
                            class="Match__player__ln">{{match.detail.nB2L}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedB">[{{match.detail.seedB}}]</span>
                        <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idB2 )">[Q]</span>
                       <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idB2 )">[WC]</span>

                    </div>

                </div>

                <div v-if="match.detail.serve == '1' || match.detail.serve == '3'"
                     class="Match__serve" v-html="ico_ball">
                </div>

                <div v-if="winner(match.detail.winner , 'b')"
                     class="Match__winner" v-html="ico_winner"></div>

                <div class="Match__set">

                    <ul>

                        <li class="Match__set__pt" v-if="match.detail.ptB">{{match.detail.ptB}}</li>
                        <li v-if="match.detail.s1B">
                            {{match.detail.s1B}}<sup v-if="match.detail.s1A > match.detail.s1B">{{match.detail.tb1}}</sup>
                        </li>
                        <li v-if="match.detail.s2B">
                            {{match.detail.s2B}}<sup v-if="match.detail.s2A > match.detail.s2B">{{match.detail.tb2}}</sup>
                        </li>
                        <li v-if="match.detail.s3B">
                            {{match.detail.s3B}}<sup v-if="match.detail.s3A > match.detail.s3B">{{match.detail.tb3}}</sup>
                        </li>

                    </ul>

                </div>

            </div>

        </div>
        </a>
    </div>
</template>

<script>
    export default {
        props: ['match', 'flagPath', 'detail', 'mode', 'type'],
        data() {
            return {
                ico_winner: window.ico_tick,
                ico_ball: window.ico_ball,
                ico_clock: window.ico_clock,
            }
        },
        methods: {
            winner(winner, team) {
                if (team == 'a' && (winner == '2' || winner == '4' || winner == '6')) {
                    return true
                }

                if (team == 'b' && (winner == '3' || winner == '5' || winner == '7')) {
                    return true
                }

                return false
            },
            matchTime(time) {
                if (time.length < 6) {
                    return time + ':00'
                }

                return time
            },
            courtDisplay(courtId) {

                let courts = window.court_stadium

                courts = courts.filter(function(court) {
                    return court.court_id == courtId
                })

                if ( courts.length > 0 ) {
                    return courts[0].stadium_name
                }

                return courtId

            },
            roundDisplay(round) {
                if (round == '1')
                    return 'Round 1'
                else if (round == '2')
                    return 'Round 2'

                if (this.type == 'wta') {
                    if (round == 'Q')
                        return 'Quarterfinals'
                    else if (round == 'S')
                        return 'Semifinals'
                    else if (round == 'F')
                        return 'Final'
                } else {
                    if (round == '5')
                        return 'Quarterfinals'
                    else if (round == '6')
                        return 'Semifinals'
                    else if (round == '7')
                        return 'Final'
                }

                return round;
            },
            initial(name) {
                return `${name.charAt(0)}.`
            },
            findPlayerById( playerId ) {
                if ( playerId == '' )
                    return false

                let found = window.all_players.filter(player => player.player_id == playerId)

                if (found.length >= 1)
                    return found[0]

                return false
            },
            showType( type, playerId ) {
                let player = this.findPlayerById( playerId )

                if ( type == 'wc' && player.iswildcard == '1' )
                    return true
                else if ( type == 'q' && player.isqualifier == '1' )
                    return true

                return false;
            },
            getFlagPath(countryCode) {
                if (!countryCode) return this.flagPath + '---.svg';
                return this.flagPath + countryCode.toLowerCase() + '.svg';
            }
        }
    }
</script>
